import Vue from 'vue';
import { ActionContext } from 'vuex';

import { LoyaltyInventoryBalance } from '@core/models/loyalty/types';
import { inventoryService } from '@core/services/loyalty/InventoryService';
import { errorGuard } from '@core/utils/ErrorGuard';
import { IState } from '@store/index';

const SET_BALANCE = 'SET_BALANCE';
const SET_ERROR = 'SET_ERROR';

export type LoyaltyState = {
    balance: LoyaltyInventoryBalance;
    error: boolean;
};

export default {
    namespaced: true,

    state: {
        balance: [],
        error: false,
    } as LoyaltyState,

    mutations: {
        [SET_BALANCE](state: LoyaltyState, balance: LoyaltyInventoryBalance) {
            Vue.set(state, 'balance', balance);
        },
        [SET_ERROR](state: LoyaltyState, value: boolean) {
            Vue.set(state, 'error', value);
        },
    },

    actions: {
        refreshBalance: ({ rootGetters, commit }: ActionContext<LoyaltyState, IState>) => {
            errorGuard(async () => {
                const user = rootGetters['data/authentication/user'];
                const balance = await inventoryService.getBalance(user.sessionId);
                commit(SET_BALANCE, balance);
                commit(SET_ERROR, false);
            }, {
                onError: () => {
                    commit(SET_BALANCE, []);
                    commit(SET_ERROR, true);
                },
            });
        },
    },
    getters: {
        balance: (store: LoyaltyState) => {
            return store.balance?.[0];
        },
    },
};
